
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexi_45fYyFYHscxIteY3nz7ZtBTn6o4JpkWqp_eEtSDIpNwMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/index.vue?macro=true";
import { default as loginqw7p4MqnFX4dRTZ0bBt9nLfDHM7Y9LkuyCegvm7OIswMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/login.vue?macro=true";
import { default as logoutX6KOwHdKwA8_45Gu_45I4q5GOQNdbZd_z_kHqY2nIqWv3LgMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/logout.vue?macro=true";
import { default as test_455006nX85p9_45YsDSyqKUjICJpYiz9NUjg6GbpqpZ5iVoDV8Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/test-500.vue?macro=true";
import { default as _91code_93K8N3cE9C3H0m0qKScWeILsFC4IOePuU7hKnqzq_6I9YMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/v/[code].vue?macro=true";
import { default as video_45call3_45NImGpP_SH_457StAk1HiRZuqkEBha4lQwWkpLrsV1YwMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/video-call.vue?macro=true";
import { default as _91slug_93VEXgdqGpAdCrH15vM_lSrureEzbKLVgWt9Kfyya9EbwMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/book/[slug].vue?macro=true";
import { default as view_45aslGP_8q0GhiOGJeLl3L7CZsMF6ygbuTGKkvobd7BDng8Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/auth/view-as.vue?macro=true";
import { default as school_45loginhfkpOTiwrfnLx_MFCkLEhh5B6A4zl0L9aj5UjPsLJJQMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-login.vue?macro=true";
import { default as faqQZju1LB02wBOuzt4NEUv3E69reZSKpVWjXORkMxSS3EMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/faq.vue?macro=true";
import { default as _91token_93Klel1YOtGtnlqGF1DjFa5oG5S5gdvpOTYNJxsoYTuLgMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/forms/[token].vue?macro=true";
import { default as school_45accessAvcA_OCHEU9Ce8HUYk9hbrgQG1z9VkRErh9TSqcpEGwMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-access.vue?macro=true";
import { default as school_45selectVizKrRSS5K4Hq6KkEnr_jWnbTvXkbMxI39vkO_KjYOoMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-select.vue?macro=true";
import { default as homeIXkgcQqfvXefOyBWpz1qtYEGCT2t525olSHIffujGcsMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/home.vue?macro=true";
import { default as teacherqm3M7xRMgz3Iie0qMWh1c17Y2vSUSotF93_OgYw_45fYAMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/signup/teacher.vue?macro=true";
import { default as contactZMTOxzPK_45eqVcZMpS9X2Q_45I_8cucpFT6HIj_45cwtWxZkMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/contact.vue?macro=true";
import { default as _91lessonId_93ffF3VyBK_e__45Wbxy2AS5vg4M6PGe3c6TfTnfDM3IA_0Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/lessons/[lessonId].vue?macro=true";
import { default as faqFKKdwL3tjg_45ssaP7Frv0xe2FjIZtzjxpq57CoiZfoUQMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/faq.vue?macro=true";
import { default as _91token_93NtjyPA8_45LPpmHir64CM7vpUtPnxzjp2ZPEX2mQOUzswMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/book/manage/[token].vue?macro=true";
import { default as homeeAgj5KcUnBahOPdzW_9eAQYeQcoQZxuWQBcw27G06DsMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/home.vue?macro=true";
import { default as home6lyH_1fe5Lm3Q7BlfkXgxW6bWbvoLJ4_ao1elcti6usMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/home.vue?macro=true";
import { default as _91id_93I9J5gmaUXARuaw5upXbdRiKsOd6G2_45Av5jMrvudkHnUMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/books/[id].vue?macro=true";
import { default as index6C5poEEQZX_5CeMno_45tasnnpksca0XxS8lOzEi6A50sMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/password-reset/index.vue?macro=true";
import { default as indexa2JpGG6txTlTKyAC5umz4JNMlq1lVvcAB5vvTmFnBFQMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/index.vue?macro=true";
import { default as indexwNUY3xMsPO1BhbpW1KtM97Vn7iyYY_45goiKWF1g6MP3gMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/books/index.vue?macro=true";
import { default as teamFLG7IYqKpw8zgeZT8oUMlO7JQfWwRt2__45ulMRbLZpfAMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/team.vue?macro=true";
import { default as _91token_93z2WFIweOsg_6gds1RVM2kKoANVGfUqQ8fYxF1HozsRsMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/password-reset/[token].vue?macro=true";
import { default as indexw8W0_qzENeXMU1vxVimMaiyMZjpT5o5lqoOcsCxg6bQMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/index.vue?macro=true";
import { default as contact_454XC8cVAlB5a_45ng022jijZVupil6UKE_455K9XyzfRxRkMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/contact.vue?macro=true";
import { default as homewarWpcHgIjPdg79CnxN_OptxS1iNQQ7CxaunFGZQ3jQMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/student-dashboard/home.vue?macro=true";
import { default as indexnX2nOiCBi9Hm_zzkVP5QUTVONVG77PkNFCZ0PpsApqUMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/account/index.vue?macro=true";
import { default as indexPIljiCOKEcCOVDugItJJN9r_4520fVMSD1gOU9WmtXc08Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/finance/index.vue?macro=true";
import { default as _91id_93hGDeqkcRYAP1Z_45FohbKyD7p02YRaIlvAlUzG8brf8IwMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/my-books/[id].vue?macro=true";
import { default as login_45lKSZADHUi6H2fyx2O7d_45wOUNr9MJ1VCYfu0Ik8LVhsMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/store-maintenance/login.vue?macro=true";
import { default as indexIGjvfO6rjKfup2aMrKG3e9a5KCLCBT3r4duv1aBoF20Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/bookings/index.vue?macro=true";
import { default as _91id_93FfAJX3J65PNboFOemudMmYplblstm7aRLHFLbY9n8bkMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/documents/[id].vue?macro=true";
import { default as indexJrwjVz_452zMNtUkK5Q0TR7M66e4dmjaekyK21ZFwH63QMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/my-books/index.vue?macro=true";
import { default as indexxHTkqHZUgdKRdo0FjHqfVhnTFrJtX_45CMvipUQ2_JbJAMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/requests/index.vue?macro=true";
import { default as index1fN_2bPD59_45wp68BtAkDtekxVSt7Wlk_cdbclyaqpMMMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/students/index.vue?macro=true";
import { default as accountP94yvQJa9pVex7qCwO6g0My0vMz4Awzw0B_kTeEmB3EMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/account.vue?macro=true";
import { default as billingHgypLtqsbFV7C9pg1qkXWdenDr0Erp7oYEF9K1yMlEAMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/billing.vue?macro=true";
import { default as reportsmp0fKK2lo8wClrg_45sjGS2cN2WZ_8NNxGa8jtC_rSIHwMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/reports.vue?macro=true";
import { default as ordersrLgCXTxN676RVAR5dFgKBZgnCdw7wHgiNy4L37T08kUMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/store-maintenance/orders.vue?macro=true";
import { default as joing5oLj5CnQa_SOpoXtlW5y_hgmWQKGo0qGctyDOqbiTMMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/code/[classroomCode]/join.vue?macro=true";
import { default as indexgOwPm3wwh79PMS1t9zRYPTN8CBS4l2ag_45UHFBgYmMBgMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/documents/index.vue?macro=true";
import { default as indexg_45awexX6tFTsVw_45rhNmKHJxLVoSZbuNjPg_9QEwHfawMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/favorites/index.vue?macro=true";
import { default as successpJ8D6xvJB1HZlDjptDlQ6OWEEnjv7vxrxOQufKMQp9MMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/payment/success.vue?macro=true";
import { default as indexOZVfR7wvLCA4QZA1sSsxXiRWchTNRlxz1OreMve06AIMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/receiving/index.vue?macro=true";
import { default as indexsrhaxChqENcgnDplaWNXIMXixoSOKnAY34OEd3wzPigMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/referrals/index.vue?macro=true";
import { default as _91id_93i6_45Jpp37m8gCrv2d7Fq73bKyWFrJZfoRopYPK_45GSfr8Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/books/[id].vue?macro=true";
import { default as account1aYzWsoJ1l7UEr_45NWrNtMvXudCE80oo7r5TgDRvuNFcMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/student-dashboard/account.vue?macro=true";
import { default as contacti1NNzTXElG3athFdHe_9POZHBu3AjJ8Nwe91x0kHzbUMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/student-dashboard/contact.vue?macro=true";
import { default as _91token_93rQ4DZZhIGcTg7FpKimSLtUxzkQOEPGtWzLsJnK_KDrQMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/assessments/public/[token].vue?macro=true";
import { default as indexgsAzBv938dZ2U5HHf1tGUk3GLWrgoagXxqNWqEWxRZQMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/code/[classroomCode]/index.vue?macro=true";
import { default as loginkQx2xkBDTDrz8JxUdlnKv8PSxzf4XzyU9ds3WoNX1CIMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/code/[classroomCode]/login.vue?macro=true";
import { default as index2NKwoy1JKdj7WRxR5IRYfhwtUAGbteJQbVdlGKTOiUwMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/attendance/index.vue?macro=true";
import { default as indexxR_45h5u276k4SYKD6a2emGxX23U9adBIvgpBG_8Inh0cMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/classrooms/index.vue?macro=true";
import { default as _91token_93jdjdfyn1GUVO4KShf0HpWqpPyA9wg_45pgtSDwvETlV3UMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-invitations/[token].vue?macro=true";
import { default as indexiVQrqMKI5C47jA1V_45yM_JLtAZWkC2a8cYLoMfrRxI5UMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/books/index.vue?macro=true";
import { default as indexVhueko2F6AFsOCHEBIfQgAvUR1HT_vSdmNs56_0ve24Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/users/index.vue?macro=true";
import { default as _91token_93N0REKoyviXYjd3YAIgw5Qcqcv1wXZ1dlnCGXT3_45wIt0Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/avaliacoes/publicas/[token].vue?macro=true";
import { default as signupWVU5VTFl_45P7QAQeK_FDb5K6Y6UC_45qX0EOVdh95tiAdsMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/code/[classroomCode]/signup.vue?macro=true";
import { default as index9_45aaoyKQjVOOYup7UZTVAgWQSXs7Jv8pka7DNRT_QDMMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/assessments/index.vue?macro=true";
import { default as indexw3Kb56YfcgkpzZUOPCCJ4jTHV1zYqC5OdsyxqLINOowMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/forms/index.vue?macro=true";
import { default as permissionstiSVJE3xB84zn81qqEhEahTHCNm_450r0RSUbFunk4hAwMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/permissions.vue?macro=true";
import { default as preferencesRXVc8nNEUackgvzv_45E7ByUIz0BPfORdDy7w3dSu_45jmAMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/preferences.vue?macro=true";
import { default as indexAQAwmB6esJP_45IPfQw8hIx5C2or8S9Xz7ULUCFvvWfukMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/store/index.vue?macro=true";
import { default as indexICOYD_4515i_rSD3MSDdihlIY0Ps7t_IiSkbJSbjQdRkoMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/account/index.vue?macro=true";
import { default as index8xQr8T8nSv3wKZCxwSPj0s7GxM3Yz7AyuS_70pA503AMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/reports/index.vue?macro=true";
import { default as indexCiHqJE_45PwET6LBRdhmIf0_45_45kP_5kEFOc54zq6JbF_JwMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/schools/index.vue?macro=true";
import { default as choose_45planbCxcbDP8ALCqiv7VFOZYai2tZWx0slJERCxE4GXBXmMMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/account/choose-plan.vue?macro=true";
import { default as indexLIX2TEnnJta45ZbcoL5tDM1cFE99iuRnpTAfFuPsV7IMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/bookings/index.vue?macro=true";
import { default as _91id_93CAHFPTaBe0pee8FOkV3WpLks85qJO9WdOiNP1a0WF2EMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/materials/[id].vue?macro=true";
import { default as indexFg7tsj1NkXcJrF_Cl_45MSlL_45uU8ZQUvw4nn0CIPPTingMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/students/index.vue?macro=true";
import { default as index_lrP55LP3TG1khWT3hCEc_V9_45vi0xcbdllFFEzIA88wMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/bookings/index.vue?macro=true";
import { default as _91id_93b9zjXwoguTg0MJvwntt704r8EN_JEa6HvDU0Kz2HqPUMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/documents/[id].vue?macro=true";
import { default as indexBsTEUv4p_45QeLenp57PzzI2L6pwUyFefxNtyLxCIwNEMMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/webhooks/index.vue?macro=true";
import { default as _91studentId_93MSCpNZrAjU426wevufKD4B_e0Kf189AigdYC3Pqm4CsMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/students/[studentId].vue?macro=true";
import { default as indexDO9UbiYXcy__GQEQRNbBS8pnp2w6R8zRVhj09cmTTREMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/entries/index.vue?macro=true";
import { default as indexpf0DO8IZTYPVImG_45BzY1Nai6jrH3m_45qEwvIWfLCwb0sMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/finance/index.vue?macro=true";
import { default as indexD7dtyGXEQP4R51__45TIsLsZ7dQCMk2ThsZM3vPgZj6DQMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/favorites/index.vue?macro=true";
import { default as indexY___45R4rRvT8zVTOzVk9It7iTIYDBgzFQ2AtVBDibjRYMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/materials/index.vue?macro=true";
import { default as indexRqc_8ttC2EZLqTlaYlLEkhAL7E5HThk3EhUlezfK51gMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/campaigns/index.vue?macro=true";
import { default as indexe6lJyffD0QbO67uQ1lds1zLCo6LhT0ubGRkrql3mI8gMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/documents/index.vue?macro=true";
import { default as index9M7ApCthdz8nDsIAS5nkOj903zhYWiT_Ce5lugvw48AMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/redirects/index.vue?macro=true";
import { default as editgA9E0sxFmjJkJ2wHeEeW18gWvWYolEjvTiK7XDLCzfEMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/assessments/[id]/edit.vue?macro=true";
import { default as indexbDlxt3_45PDl3gnwbKow5IM9XsERqNS38nMbcieqS_45LWUMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/bookings/index.vue?macro=true";
import { default as _91id_93Q01jKAryK6_pD0LN1zYt4v3ILXj8n6HcLD0YXY9MWFoMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/documents/[id].vue?macro=true";
import { default as _91id_9364k1JRQwliAy_452J_45ZSY12EuFYfi_x5UpmtUe0Q6lGEYMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/materials/[id].vue?macro=true";
import { default as indexhX79rJL8Q90SoEneYfFq6hciGTKCpiM1KXC7iUCyT0sMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/requests/index.vue?macro=true";
import { default as indexEDfX5sqjhHLj_JQo5RhckU5Y2CMl8WKA6ZIBgBreBwsMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/students/index.vue?macro=true";
import { default as indexvuOeUUxxqVXrbv91tbX8WVY925LAoBHH02NdwOVgwFgMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/attendance/index.vue?macro=true";
import { default as indexJwzK4bn95IQFO4OEzCEoFb_GS5dktjUjdNHzfk6i_45LIMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/classrooms/index.vue?macro=true";
import { default as _91id_931xZ21nUgvbJjN1XkuJOl7CqTxAsEsVdJVsCDPYOl_45k8Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/student-dashboard/payments/[id].vue?macro=true";
import { default as indexENbqAHmN4D945XWRi0gZNNIeuiTL5p75gP0DHEdtl_oMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/student-dashboard/rewards/index.vue?macro=true";
import { default as indexhqRGzLRQ6kD8U2qe2MmaViS0LKEQ3UTZa_rx_9igHscMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/ai/control/index.vue?macro=true";
import { default as indexfZZtWhuzXEc9b3j5X5sZLS5upxfKVsXrtVlKcrz8CBQMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/assessments/[id]/index.vue?macro=true";
import { default as index_UwBPWYGpYac6M_nEY6b222FtjGb8HtAUi84_45Bfb_TcMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/documents/index.vue?macro=true";
import { default as indexN6rFuISDg4jZ8VtQZBK9mE5Ii70Qux4moUi2W0hREsIMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/interests/index.vue?macro=true";
import { default as indexkLlWsaMJOVLhoufQtO76FBx6G7u0DznHxOTYhsj9_80Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/materials/index.vue?macro=true";
import { default as index_RPXxdAoCJkaSfqzHBSLvqdNy5LQ8ExxHNIn1LDRJcoMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/receiving/index.vue?macro=true";
import { default as indexgA0nL6wTJlSUZlC8M26_oyMRaW7gYNCkyk_4563C_g4eEMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/assessments/index.vue?macro=true";
import { default as indexMII7YevWFnhjvxJomjMSDJcrSeBs_456RcLAVy1U_6G_45cMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/student-dashboard/payments/index.vue?macro=true";
import { default as index2o7Nf35Vx8gYS_45ncgoXwcpt43iKYKiSNKUNaydJUBO4Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/student-dashboard/requests/index.vue?macro=true";
import { default as indexz9oEn4LGZXQgaemepnF_45zToKENiEjh3R76dceqHAKikMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/assessments/index.vue?macro=true";
import { default as simulatoru80fL_454fk9PsMQZSI7Ccn73nKARVDHWs7xYJg6yZ4oQMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/simulator.vue?macro=true";
import { default as indexDLEkXVp3wBY_JqAEYCGnzl7Zb9H3goPgz4hJIJ1L89MMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/video-calls/index.vue?macro=true";
import { default as missing_45data7DsBckKEbTRW5yMuMq9j8czHnez_49fuaVLZz4n6PeYMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/code/[classroomCode]/missing-data.vue?macro=true";
import { default as processingveeIPq2EfvX5g_45H4sSKAiUC1NsLSxkDRYl_45LU85qw_45QMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/payment/[id]/processing.vue?macro=true";
import { default as indexaKuduL274uI5UMApqphuVhwwwqa3AGfonkAwqAcjHWIMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/attendance/index.vue?macro=true";
import { default as index1wM3RHCMEOSChjg9C_FuXJRJh0ZzxZzTtMzLpTt1l6UMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/classrooms/index.vue?macro=true";
import { default as indexi9fA62IxXSpwYnET7A_eUoMBxkwLgAavQSPgzpIQSPwMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/forms/[id]/index.vue?macro=true";
import { default as _91id_93jJ_455ib3Tz_457BblUlj1XVYBnLU_45SRD2kVQ5Rqw5COuQYMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/student-dashboard/classrooms/[id].vue?macro=true";
import { default as create4U6Eet33OwoY3uUj_45k7e91OB5wiXQ74GjEccJrMXStQMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/assessments/create.vue?macro=true";
import { default as resultsHxKLaqY4BxFGM356HPYoPhHH5uFTdxitVMxtGcNlZ20Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/assessments/[id]/results.vue?macro=true";
import { default as _91id_93JWtqvX1ZKIPsqDqTeKKF8QEZcQ1e2JnfkkKp6DkN1WMMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/documents/generated/[id].vue?macro=true";
import { default as update_45user_45dataMi7MuLkyVyYGF6ZNZR90uyT749Ao9GEPh1Mv_45togbfIMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/payment/update-user-data.vue?macro=true";
import { default as indexWQnzb45W1aYLVjHCcFlIThyChBSuQxuJy1iCt4_45LuKMMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/assessments/index.vue?macro=true";
import { default as indexhDYrffZ3LcMiMEZ_ugGZczjF_X3dsnAsac4GvMc_45ASsMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/student-dashboard/agreements/index.vue?macro=true";
import { default as _91id_93ruax59B5Y_7tYfXO3rL7qWIXt22WYQhLTqCVR3xMyaAMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/student-dashboard/assessments/[id].vue?macro=true";
import { default as _91teachingClassId_93zDqh4dE8kP9AuzSgdOYRNd2V7W5KPFOEfUIgsQOnobEMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/teaching-classes/[teachingClassId].vue?macro=true";
import { default as indexIs6KeCmRP4iE21Lq12MEieO53h0YSGDd4j_pH129XNAMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/ai/cost-audit/index.vue?macro=true";
import { default as index1eNbG4YAZU2S0UBhl2q_45tcIr3tYnl_4523hMF1fpz_45e18Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/feature-flags/index.vue?macro=true";
import { default as indexsXZhakL_RZNLgs_45zqZI_am6KivXbB1XJaHOvazpO05cMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/notifications/index.vue?macro=true";
import { default as new9F7XQSF5VFD9fHq0JPdypQj4iKDht_lwphX7XsGybMYMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/coupons/new.vue?macro=true";
import { default as indexd5YzC3Viy6FRoStrX2KQ3kq8wgj4nC10bkmLHDG2y_oMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/storage-audit/index.vue?macro=true";
import { default as confirmation2v7r5zlDYZOt373_45yfWMon_vSbhP7L_45NVMR_45zwcXrQoMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/payment/[id]/confirmation.vue?macro=true";
import { default as indexpjetWpZ9EQGEZhI7OTQ4o5Y_45oCg8pu7SJlmnA_45WBaYcMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/payment/change-plan/index.vue?macro=true";
import { default as settingsLVFPA_45LoQMQvikduT50DHY8BTrFTAz6PLmFICbctH5sMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/documents/settings.vue?macro=true";
import { default as indexU8srLvV1Niif35D1Xs7c8zOqaQwkE_45LT2HBkOiVb8tcMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/integrations/index.vue?macro=true";
import { default as indexEH9QN4tYDyjFvHTsuB57_45q5AYzy_mdok4IwlAYCSv1oMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/store/orders/index.vue?macro=true";
import { default as indexT5P09mWoh2VZj2Ezj704imFEuH4u_KoKLbM_z0UariAMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/student-dashboard/assessments/index.vue?macro=true";
import { default as policiesno2GVbqIAzZMhol5ylvL6WqWG9s50TLhbigaII8uhv4Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/assessments/policies.vue?macro=true";
import { default as indexBmBHKIpVJ6Kq2Q5iCMVzx0n_JscUcKcl61CnDsrC590Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/orders/index.vue?macro=true";
import { default as newSkWC8SMGjLaKlGeuxfiy9Ixd1wby7JDXOz_7GmyDudQMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/products/new.vue?macro=true";
import { default as indexYjHUqnjY_l70qNtajgA7mWJezTJLOlAHnnyrjqdmVt0Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/users/[userId]/index.vue?macro=true";
import { default as _91webhookId_93WtBPJLnV_nutowitEnHh9_4CJKraIaggSGeEtoGrmF8Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/webhooks/[webhookId].vue?macro=true";
import { default as change_45credit_45cardlzMdQzFB8flzgiOswzPYrknhYPzV_hZDqG14_45e2iGY4Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/payment/change-credit-card.vue?macro=true";
import { default as indexI6cbk8DVrPZOnoSnnSzX9hsCYwQI4KS_xffPqnLd_45GoMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/notifications/index.vue?macro=true";
import { default as editJzNPTerxeUNN7yl81THCgKrPEn0aiU2ue62kVJzv9fwMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/assessments/[id]/edit.vue?macro=true";
import { default as editNRrkVP63l_cT4Kx0gTDOJmXzJUAJiwSp4hel3PQ8EJUMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/assessments/[id]/edit.vue?macro=true";
import { default as indexcoNRd4YDnYNMas63171LPY255bmTUS5GbqHI_Vb3YX0Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/background-jobs/index.vue?macro=true";
import { default as indexsgFBfb5_45M8Qqw_ivsaafemMHm0pu_MzgZ_45rrtwGfe34Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content-quality/index.vue?macro=true";
import { default as indexF3q89Z_uwMkKXNEPTU2thUH8v97LVoT6aMAmbm_k9XQMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/coupons/index.vue?macro=true";
import { default as manage_45subscription4B2_kUdsqg0canvJX3yllkk_UdRyOYbYlkl4h4uFQp0Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/account/manage-subscription.vue?macro=true";
import { default as change_45plan_45successhlL7NxFrUBmngezWcnxg056dUz_2kiwVmq4iAH5BCa4Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/payment/change-plan-success.vue?macro=true";
import { default as indexXzU0o3okHCZNiqmVWOFqFJBlVEpz26TlsAFKR8RgkD0Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/interests/[id]/index.vue?macro=true";
import { default as indexwvDprKEC5LIZ_45N_e3CnNHrIsR9tghHm_fxluPxuo66AMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/store/settings/index.vue?macro=true";
import { default as indexGGX_45CSW_45Is2_QbSG3kXkR1MhLWHyF2OcowRxHczScb8Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/assessments/[id]/index.vue?macro=true";
import { default as indexpDjFLmedMuqsgXWQBnh8yqPl36ZfVBt3Ake8ni0GPAMMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/assessments/[id]/index.vue?macro=true";
import { default as auditst57KCYoVWIkHEek1AURUDkhMKkwUvnquN_454XLqvMykoMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content-quality/audits.vue?macro=true";
import { default as indexMru_4C4SmbjdS51CBlfDdNau8WyjXbTqmVoSp35rodIMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/outreach/schools/index.vue?macro=true";
import { default as index3_v0vpAO_4FT5LBmdMSUbV9SGYatQrPpuoTWrLhV7RcMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/products/index.vue?macro=true";
import { default as editCrWSkGtrGMPkzedlSHDz1Xm_Whea4IJC6WiR9C16vi0Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/assessments/[id]/edit.vue?macro=true";
import { default as indexSwSq71Z1eWyBViexoFgp5lXo9KpXfIq_45qIQ4xXEvk5QMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/referrals/index.vue?macro=true";
import { default as new_G0YwyH8GJeT9fKBM_45jTLh0APp_45Xd49EWY_45aWYz_45OQ4Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/user-access-configs/new.vue?macro=true";
import { default as indexS5WoLcpVs08mZ_p9CyRq3CgSNyD86iqcc_UozSDgv1IMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/assessments/[id]/index.vue?macro=true";
import { default as indexrIqTacPUoQ8r6US0VIJoJNzY1K4LASqSeHB7VTXU0T4Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/store/categories/index.vue?macro=true";
import { default as resultsGUrYBHn2V8PpA4c4Kn_oCsQlbe28gELyx8tleOO_456_oMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/assessments/[id]/results.vue?macro=true";
import { default as newI_45bg72Rhn1EBihJCakYKuOevMU_TnWP6z0ZARqe1LSEMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content/lesson-plans/new.vue?macro=true";
import { default as _91orderId_931mVkBm3i_LINR8qJR1WmZQs9v6Lh9l0YlGFUh2YEJYQMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/orders/[orderId].vue?macro=true";
import { default as student_45login_45tokenJOSUmlja7VksUF9W5NKR79_45vrl44G3uVPPh7mnDKDWgMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/code/[classroomCode]/student-login-token.vue?macro=true";
import { default as index3eV3r4WE_45EghNwX21eXns6w9bRpkx7PuMDtwevkScBgMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/classrooms/[classroomId]/index.vue?macro=true";
import { default as _91templateId_93zBzfKnAoVRuTwW_2YKo5BbhSttovhiKuefxvc9nGKmAMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/documents/preview/[templateId].vue?macro=true";
import { default as user_45payment_45datap8wNj8U6CRU9zTV7obM_BnjKU5tv_45XFlgM8gaBJr3dQMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/payment/[id]/user-payment-data.vue?macro=true";
import { default as bulk_45generatehn4ygWIXt88IN5Zh2kG8cZt24RgCBXuXzDXZiUNiOc8Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/assessments/bulk-generate.vue?macro=true";
import { default as index2fssuGBkJp7bAfaByRYvEfTS3lqQdKKKGD5on5ucABwMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content/all-lessons/index.vue?macro=true";
import { default as indexpH5Wf4qB9knyRwBdtpmScj6pxAPV_45YS_EOFB1IIDXgMMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/user-access-configs/index.vue?macro=true";
import { default as _91id_932AnCVy6CZnJBkBrbT5vsGEohiXWiC51NxhOo_45DS_45U0AMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/documents/generated/[id].vue?macro=true";
import { default as index1cC3TIHoggSIXT6eTmzsADt6QlceLacxIRH4_45U00S98Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/students/[studentId]/index.vue?macro=true";
import { default as index5PQSJAB46V4_45fTNvRfAX_l9UF6Zsf5Te1sOBfNkubh0Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/assessments/attempts/index.vue?macro=true";
import { default as index7CjhZZOFlmdqTOOBAlTaVbLIW6oAFbirDqb_0E0eeKwMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content/lesson-plans/index.vue?macro=true";
import { default as indexY7uNACK08sPsHpg4yLkllqBgxHWP_Wha4BTxP1W5RGoMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/subscriptions/index.vue?macro=true";
import { default as entry9NQmVNeLkD7tZP4q7z_k36l1xGexcqQt_tFd0UPXebQMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/students/[studentId]/entry.vue?macro=true";
import { default as indexigE_457luoRiUUYx6eZIc9RpDUyNlM7BuPN5ixYsXubYcMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/students/[studentId]/index.vue?macro=true";
import { default as reorderDqS1tEP8WUw5m5JhUP7aaM2Y2Xo8PLRweC2fN9bYHusMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content/lesson-plans/reorder.vue?macro=true";
import { default as index2f0geLQEvEDtJ10kMaYHxXeeIgKMdftzSqBfNAwLmycMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/notifications/whatsapp/index.vue?macro=true";
import { default as indexwBIFy1s3cS8gw4N3RUKHcaT6s8bKNr5EDF8U3eRRzBkMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content-quality/reports/index.vue?macro=true";
import { default as success_45updated_45credit_45cardY9xD_FKUklPpquHgvAeZYb_45juRLFxaxxUOVYmzqyYEcMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/payment/success-updated-credit-card.vue?macro=true";
import { default as indexetoVOb6UFyw1vR0vDLXPgwkctlJuyuY02umeCpiCH3kMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/classrooms/[classroomId]/index.vue?macro=true";
import { default as newrtVPrhCgyfpnm_45rgoG2U0iiOhzvVDLqXBMXttheR9iEMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/payment-processors/new.vue?macro=true";
import { default as newhh9D2ZW8QRwT_hrHIFqXc3XOfjecVsLhd53T1bwuxxIMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/subscription-plans/new.vue?macro=true";
import { default as index9A2sZA5DrMSfHyOxLzUh_45_XTC9R2VWJy36FR8FznWN8Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/entitlements/usage-events/index.vue?macro=true";
import { default as editPqDJpgAAOhdLteJWfYf_45YprpdRTsoUIgZMZS_wuiNdQMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/coupons/[couponId]/edit.vue?macro=true";
import { default as _91attemptId_93RaSDj0N2vC6VytSrmQiluIesi3nshahB2cxQgQibUMYMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/assessments/[id]/attempts/[attemptId].vue?macro=true";
import { default as indexjhCyTVnubGC1xDsLOmDNGhezgwLMRT1T33cNQQ93NKMMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/classrooms/[classroomId]/index.vue?macro=true";
import { default as _91templateId_93MtHRYdoRTMfB1IaS0XhGqgwO2YzY4KptbHOck0jm7CsMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/documents/preview/[templateId].vue?macro=true";
import { default as _91attemptId_93WOdht1yHRwqO6oiol8M4EVtdMxxYLKHZjyc3u9_455HKwMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/assessments/attempts/[attemptId].vue?macro=true";
import { default as indexnxyxcI14xUaDFpX2_45yURdQa3Is5rpJoxuynXI_45T09qcMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content-quality/[lessonId]/index.vue?macro=true";
import { default as indexkTqizuG4SXOu3FymzDllljVZOdKfNdsUtROT_45b9AKvgMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/payment-processors/index.vue?macro=true";
import { default as indexKSOQo27t4W8Z6d_45IfxSWui2ak7TO8ezDM2jp_MgrR3UMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/subscription-plans/index.vue?macro=true";
import { default as createpSxWEpZJegrEfgVUPliQBc_LzFQI9J4b0l1XJZaXVykMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/assessments/[id]/questions/create.vue?macro=true";
import { default as _91reportId_93Ba418QIhKjD_IzGG8GfLFszqVQoZhitEEv8_45UQVjexEMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content-quality/reports/[reportId].vue?macro=true";
import { default as editdeVkp2qWzSZsyHgJKkoXRww0qs7WoceUBnlOtnkQxr0Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/user-access-configs/[configId]/edit.vue?macro=true";
import { default as _91attemptId_93DQG_l2BKk7QZ9Kzv_45HwNhj1rnDWItJYDq4QSr2eNZDcMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/assessments/[id]/attempts/[attemptId].vue?macro=true";
import { default as _91contactId_93h7KDuywjzp69_459Yc4JmrZTQyio7md9No7iYp_45r_eC44Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/assessments/[id]/contacts/[contactId].vue?macro=true";
import { default as newsWUffrftCzAISgEN9aQmGL3k1Jbdvek8QkYS0M720jcMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/subscription-plans/provider/new.vue?macro=true";
import { default as edit5bsmSPp4cFnG_45WuymYZYJ49LeUZTyWtfCoVoRwH2uAYMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content/lesson-plans/[lessonPlanId]/edit.vue?macro=true";
import { default as indexkwMUzl96aumUaobF_45cENwt9OO1GNh3qazyJjF4fozNkMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content/lesson-plans/[lessonPlanId]/index.vue?macro=true";
import { default as indexG33x2uObCotUfzyta1QPt1fjNG73ehWD2mTaMCTE_MAMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/subscription-plans/provider/index.vue?macro=true";
import { default as _91providerChargeId_93Ekx8dcAWbfaytsmmUMHXN5n1ZUbH_45jFpkWPv_45taMt48Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/pagarme/charges/[providerChargeId].vue?macro=true";
import { default as _91providerInvoiceId_93mXvIprpK_45k7wrDaKZ9OBtavlhkncIqnIkZkxmZT9sPgMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/pagarme/invoices/[providerInvoiceId].vue?macro=true";
import { default as indexWnpxvLAFywVNz8YS69IB3decoJ6opR8UNZ49YZ3jYWkMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/subscriptions/[subscriptionId]/index.vue?macro=true";
import { default as new9ACt_45fPCI5mJLbdDtjNxxsImku1nhBrjeVmprjWOE_45sMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content/lesson-plans/[lessonPlanId]/lessons/new.vue?macro=true";
import { default as confirmationw9AYtd2IAtYxcscycJwnrrjLoSOGMSEYUZ3UWZf2oLEMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/payment/change-plan/[subscriptionPlanId]/confirmation.vue?macro=true";
import { default as indexKjSbuUuJ276WFmDtaBwuyDWSioOwNFzGPQs_FD261fUMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content/lesson-plans/[lessonPlanId]/lessons/index.vue?macro=true";
import { default as edith48u072diLSMZSm6TSHZiOcFJjT9sdaYIg_IB0l3DecMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/subscription-plans/[subscriptionPlanId]/edit.vue?macro=true";
import { default as indexWMDrV3B_efRwWOoSPNrlULJ_MMyGkYLsUbrBWyUSZQwMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/subscription-plans/[subscriptionPlanId]/index.vue?macro=true";
import { default as _91variant_93E2ofyOzVnhdR8izufvrzsumwSjU_jazLKMmrnrb0IEIMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content-quality/revisions/[revisionId]/preview/[variant].vue?macro=true";
import { default as edit_bkfb4O3ksUk5_5knsleNagP3iAoStlj58ZnduQ4zP8Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content/lesson-plans/[lessonPlanId]/lessons/[lessonId]/edit.vue?macro=true";
import { default as indexLNt9ipwpw0YFCLO0jKj2NGMFaIpVmvhBz21B93_45MXMUMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content/lesson-plans/[lessonPlanId]/lessons/[lessonId]/index.vue?macro=true";
import { default as customizeqMk3pKMKPpIX1lWAR_45NAOoHVSAOauZbUZBCJRGwzEX8Meta } from "/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/complementary-activities/[sourceType]/[sourceId]/[assessmentId]/customize.vue?macro=true";
import { default as customizeXun9wmR8MPvNH5FGMuecBaZReYR4RAhgncmhHY3Vo2sMeta } from "/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/complementary-activities/[sourceType]/[sourceId]/[assessmentId]/customize.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexi_45fYyFYHscxIteY3nz7ZtBTn6o4JpkWqp_eEtSDIpNwMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginqw7p4MqnFX4dRTZ0bBt9nLfDHM7Y9LkuyCegvm7OIswMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/login.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logoutX6KOwHdKwA8_45Gu_45I4q5GOQNdbZd_z_kHqY2nIqWv3LgMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/logout.vue")
  },
  {
    name: "test-500",
    path: "/test-500",
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/test-500.vue")
  },
  {
    name: "v-code",
    path: "/v/:code()",
    meta: _91code_93K8N3cE9C3H0m0qKScWeILsFC4IOePuU7hKnqzq_6I9YMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/v/[code].vue")
  },
  {
    name: "video-call",
    path: "/video-call",
    meta: video_45call3_45NImGpP_SH_457StAk1HiRZuqkEBha4lQwWkpLrsV1YwMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/video-call.vue")
  },
  {
    name: "book-slug",
    path: "/book/:slug()",
    meta: _91slug_93VEXgdqGpAdCrH15vM_lSrureEzbKLVgWt9Kfyya9EbwMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/book/[slug].vue")
  },
  {
    name: "auth-view-as",
    path: "/auth/view-as",
    meta: view_45aslGP_8q0GhiOGJeLl3L7CZsMF6ygbuTGKkvobd7BDng8Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/auth/view-as.vue")
  },
  {
    name: "school-login",
    path: "/school-login",
    meta: school_45loginhfkpOTiwrfnLx_MFCkLEhh5B6A4zl0L9aj5UjPsLJJQMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-login.vue")
  },
  {
    name: "dashboard-faq",
    path: "/dashboard/faq",
    meta: faqQZju1LB02wBOuzt4NEUv3E69reZSKpVWjXORkMxSS3EMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/faq.vue")
  },
  {
    name: "forms-token",
    path: "/forms/:token()",
    meta: _91token_93Klel1YOtGtnlqGF1DjFa5oG5S5gdvpOTYNJxsoYTuLgMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/forms/[token].vue")
  },
  {
    name: "school-access",
    path: "/school-access",
    meta: school_45accessAvcA_OCHEU9Ce8HUYk9hbrgQG1z9VkRErh9TSqcpEGwMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-access.vue")
  },
  {
    name: "school-select",
    path: "/school-select",
    meta: school_45selectVizKrRSS5K4Hq6KkEnr_jWnbTvXkbMxI39vkO_KjYOoMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-select.vue")
  },
  {
    name: "dashboard-home",
    path: "/dashboard/home",
    meta: homeIXkgcQqfvXefOyBWpz1qtYEGCT2t525olSHIffujGcsMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/home.vue")
  },
  {
    name: "signup-teacher",
    path: "/signup/teacher",
    meta: teacherqm3M7xRMgz3Iie0qMWh1c17Y2vSUSotF93_OgYw_45fYAMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/signup/teacher.vue")
  },
  {
    name: "dashboard-contact",
    path: "/dashboard/contact",
    meta: contactZMTOxzPK_45eqVcZMpS9X2Q_45I_8cucpFT6HIj_45cwtWxZkMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/contact.vue")
  },
  {
    name: "lessons-lessonId",
    path: "/lessons/:lessonId()",
    meta: { ...(_91lessonId_93ffF3VyBK_e__45Wbxy2AS5vg4M6PGe3c6TfTnfDM3IA_0Meta || {}), ...{"middleware":["classroom-auth"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/lessons/[lessonId].vue")
  },
  {
    name: "school-teacher-faq",
    path: "/school-teacher/faq",
    meta: faqFKKdwL3tjg_45ssaP7Frv0xe2FjIZtzjxpq57CoiZfoUQMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/faq.vue")
  },
  {
    name: "book-manage-token",
    path: "/book/manage/:token()",
    meta: _91token_93NtjyPA8_45LPpmHir64CM7vpUtPnxzjp2ZPEX2mQOUzswMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/book/manage/[token].vue")
  },
  {
    name: "school-teacher-home",
    path: "/school-teacher/home",
    meta: homeeAgj5KcUnBahOPdzW_9eAQYeQcoQZxuWQBcw27G06DsMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/home.vue")
  },
  {
    name: "admin-dashboard-home",
    path: "/admin-dashboard/home",
    meta: home6lyH_1fe5Lm3Q7BlfkXgxW6bWbvoLJ4_ao1elcti6usMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/home.vue")
  },
  {
    name: "dashboard-books-id",
    path: "/dashboard/books/:id()",
    meta: _91id_93I9J5gmaUXARuaw5upXbdRiKsOd6G2_45Av5jMrvudkHnUMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/books/[id].vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: index6C5poEEQZX_5CeMno_45tasnnpksca0XxS8lOzEi6A50sMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/password-reset/index.vue")
  },
  {
    name: "school-teacher",
    path: "/school-teacher",
    meta: indexa2JpGG6txTlTKyAC5umz4JNMlq1lVvcAB5vvTmFnBFQMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/index.vue")
  },
  {
    name: "dashboard-books",
    path: "/dashboard/books",
    meta: indexwNUY3xMsPO1BhbpW1KtM97Vn7iyYY_45goiKWF1g6MP3gMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/books/index.vue")
  },
  {
    name: "school-dashboard-team",
    path: "/school-dashboard/team",
    meta: teamFLG7IYqKpw8zgeZT8oUMlO7JQfWwRt2__45ulMRbLZpfAMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/team.vue")
  },
  {
    name: "password-reset-token",
    path: "/password-reset/:token()",
    meta: _91token_93z2WFIweOsg_6gds1RVM2kKoANVGfUqQ8fYxF1HozsRsMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/password-reset/[token].vue")
  },
  {
    name: "school-dashboard",
    path: "/school-dashboard",
    meta: indexw8W0_qzENeXMU1vxVimMaiyMZjpT5o5lqoOcsCxg6bQMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/index.vue")
  },
  {
    name: "school-teacher-contact",
    path: "/school-teacher/contact",
    meta: contact_454XC8cVAlB5a_45ng022jijZVupil6UKE_455K9XyzfRxRkMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/contact.vue")
  },
  {
    name: "student-dashboard-home",
    path: "/student-dashboard/home",
    meta: homewarWpcHgIjPdg79CnxN_OptxS1iNQQ7CxaunFGZQ3jQMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/student-dashboard/home.vue")
  },
  {
    name: "dashboard-account",
    path: "/dashboard/account",
    meta: indexnX2nOiCBi9Hm_zzkVP5QUTVONVG77PkNFCZ0PpsApqUMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/account/index.vue")
  },
  {
    name: "dashboard-finance",
    path: "/dashboard/finance",
    meta: indexPIljiCOKEcCOVDugItJJN9r_4520fVMSD1gOU9WmtXc08Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/finance/index.vue")
  },
  {
    name: "dashboard-my-books-id",
    path: "/dashboard/my-books/:id()",
    meta: { ...(_91id_93hGDeqkcRYAP1Z_45FohbKyD7p02YRaIlvAlUzG8brf8IwMeta || {}), ...{"middleware":["individual-materials"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/my-books/[id].vue")
  },
  {
    name: "store-maintenance-login",
    path: "/store-maintenance/login",
    meta: login_45lKSZADHUi6H2fyx2O7d_45wOUNr9MJ1VCYfu0Ik8LVhsMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/store-maintenance/login.vue")
  },
  {
    name: "dashboard-bookings",
    path: "/dashboard/bookings",
    meta: indexIGjvfO6rjKfup2aMrKG3e9a5KCLCBT3r4duv1aBoF20Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/bookings/index.vue")
  },
  {
    name: "dashboard-documents-id",
    path: "/dashboard/documents/:id()",
    meta: { ...(_91id_93FfAJX3J65PNboFOemudMmYplblstm7aRLHFLbY9n8bkMeta || {}), ...{"middleware":["documents"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/documents/[id].vue")
  },
  {
    name: "dashboard-my-books",
    path: "/dashboard/my-books",
    meta: { ...(indexJrwjVz_452zMNtUkK5Q0TR7M66e4dmjaekyK21ZFwH63QMeta || {}), ...{"middleware":["individual-materials"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/my-books/index.vue")
  },
  {
    name: "dashboard-requests",
    path: "/dashboard/requests",
    meta: indexxHTkqHZUgdKRdo0FjHqfVhnTFrJtX_45CMvipUQ2_JbJAMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/requests/index.vue")
  },
  {
    name: "dashboard-students",
    path: "/dashboard/students",
    meta: index1fN_2bPD59_45wp68BtAkDtekxVSt7Wlk_cdbclyaqpMMMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/students/index.vue")
  },
  {
    name: "school-dashboard-account",
    path: "/school-dashboard/account",
    meta: accountP94yvQJa9pVex7qCwO6g0My0vMz4Awzw0B_kTeEmB3EMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/account.vue")
  },
  {
    name: "school-dashboard-billing",
    path: "/school-dashboard/billing",
    meta: billingHgypLtqsbFV7C9pg1qkXWdenDr0Erp7oYEF9K1yMlEAMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/billing.vue")
  },
  {
    name: "school-dashboard-reports",
    path: "/school-dashboard/reports",
    meta: reportsmp0fKK2lo8wClrg_45sjGS2cN2WZ_8NNxGa8jtC_rSIHwMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/reports.vue")
  },
  {
    name: "store-maintenance-orders",
    path: "/store-maintenance/orders",
    meta: ordersrLgCXTxN676RVAR5dFgKBZgnCdw7wHgiNy4L37T08kUMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/store-maintenance/orders.vue")
  },
  {
    name: "code-classroomCode-join",
    path: "/code/:classroomCode()/join",
    meta: joing5oLj5CnQa_SOpoXtlW5y_hgmWQKGo0qGctyDOqbiTMMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/code/[classroomCode]/join.vue")
  },
  {
    name: "dashboard-documents",
    path: "/dashboard/documents",
    meta: { ...(indexgOwPm3wwh79PMS1t9zRYPTN8CBS4l2ag_45UHFBgYmMBgMeta || {}), ...{"middleware":["documents"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/documents/index.vue")
  },
  {
    name: "dashboard-favorites",
    path: "/dashboard/favorites",
    meta: indexg_45awexX6tFTsVw_45rhNmKHJxLVoSZbuNjPg_9QEwHfawMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/favorites/index.vue")
  },
  {
    name: "dashboard-payment-success",
    path: "/dashboard/payment/success",
    meta: successpJ8D6xvJB1HZlDjptDlQ6OWEEnjv7vxrxOQufKMQp9MMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/payment/success.vue")
  },
  {
    name: "dashboard-receiving",
    path: "/dashboard/receiving",
    meta: indexOZVfR7wvLCA4QZA1sSsxXiRWchTNRlxz1OreMve06AIMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/receiving/index.vue")
  },
  {
    name: "dashboard-referrals",
    path: "/dashboard/referrals",
    meta: { ...(indexsrhaxChqENcgnDplaWNXIMXixoSOKnAY34OEd3wzPigMeta || {}), ...{"middleware":["referral-program"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/referrals/index.vue")
  },
  {
    name: "school-teacher-books-id",
    path: "/school-teacher/books/:id()",
    meta: _91id_93i6_45Jpp37m8gCrv2d7Fq73bKyWFrJZfoRopYPK_45GSfr8Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/books/[id].vue")
  },
  {
    name: "student-dashboard-account",
    path: "/student-dashboard/account",
    meta: account1aYzWsoJ1l7UEr_45NWrNtMvXudCE80oo7r5TgDRvuNFcMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/student-dashboard/account.vue")
  },
  {
    name: "student-dashboard-contact",
    path: "/student-dashboard/contact",
    meta: contacti1NNzTXElG3athFdHe_9POZHBu3AjJ8Nwe91x0kHzbUMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/student-dashboard/contact.vue")
  },
  {
    name: "assessments-public-token",
    path: "/assessments/public/:token()",
    meta: _91token_93rQ4DZZhIGcTg7FpKimSLtUxzkQOEPGtWzLsJnK_KDrQMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/assessments/public/[token].vue")
  },
  {
    name: "code-classroomCode",
    path: "/code/:classroomCode()",
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/code/[classroomCode]/index.vue")
  },
  {
    name: "code-classroomCode-login",
    path: "/code/:classroomCode()/login",
    meta: loginkQx2xkBDTDrz8JxUdlnKv8PSxzf4XzyU9ds3WoNX1CIMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/code/[classroomCode]/login.vue")
  },
  {
    name: "dashboard-attendance",
    path: "/dashboard/attendance",
    meta: index2NKwoy1JKdj7WRxR5IRYfhwtUAGbteJQbVdlGKTOiUwMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/attendance/index.vue")
  },
  {
    name: "dashboard-classrooms",
    path: "/dashboard/classrooms",
    meta: indexxR_45h5u276k4SYKD6a2emGxX23U9adBIvgpBG_8Inh0cMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/classrooms/index.vue")
  },
  {
    name: "school-invitations-token",
    path: "/school-invitations/:token()",
    meta: _91token_93jdjdfyn1GUVO4KShf0HpWqpPyA9wg_45pgtSDwvETlV3UMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-invitations/[token].vue")
  },
  {
    name: "school-teacher-books",
    path: "/school-teacher/books",
    meta: indexiVQrqMKI5C47jA1V_45yM_JLtAZWkC2a8cYLoMfrRxI5UMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/books/index.vue")
  },
  {
    name: "admin-dashboard-users",
    path: "/admin-dashboard/users",
    meta: { ...(indexVhueko2F6AFsOCHEBIfQgAvUR1HT_vSdmNs56_0ve24Meta || {}), ...{"middleware":["superuser-admin"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/users/index.vue")
  },
  {
    name: "avaliacoes-publicas-token",
    path: "/avaliacoes/publicas/:token()",
    meta: _91token_93N0REKoyviXYjd3YAIgw5Qcqcv1wXZ1dlnCGXT3_45wIt0Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/avaliacoes/publicas/[token].vue")
  },
  {
    name: "code-classroomCode-signup",
    path: "/code/:classroomCode()/signup",
    meta: signupWVU5VTFl_45P7QAQeK_FDb5K6Y6UC_45qX0EOVdh95tiAdsMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/code/[classroomCode]/signup.vue")
  },
  {
    name: "dashboard-assessments",
    path: "/dashboard/assessments",
    meta: index9_45aaoyKQjVOOYup7UZTVAgWQSXs7Jv8pka7DNRT_QDMMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/assessments/index.vue")
  },
  {
    name: "school-dashboard-forms",
    path: "/school-dashboard/forms",
    meta: { ...(indexw3Kb56YfcgkpzZUOPCCJ4jTHV1zYqC5OdsyxqLINOowMeta || {}), ...{"middleware":["school-forms"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/forms/index.vue")
  },
  {
    name: "school-dashboard-permissions",
    path: "/school-dashboard/permissions",
    meta: permissionstiSVJE3xB84zn81qqEhEahTHCNm_450r0RSUbFunk4hAwMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/permissions.vue")
  },
  {
    name: "school-dashboard-preferences",
    path: "/school-dashboard/preferences",
    meta: preferencesRXVc8nNEUackgvzv_45E7ByUIz0BPfORdDy7w3dSu_45jmAMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/preferences.vue")
  },
  {
    name: "school-dashboard-store",
    path: "/school-dashboard/store",
    meta: indexAQAwmB6esJP_45IPfQw8hIx5C2or8S9Xz7ULUCFvvWfukMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/store/index.vue")
  },
  {
    name: "school-teacher-account",
    path: "/school-teacher/account",
    meta: indexICOYD_4515i_rSD3MSDdihlIY0Ps7t_IiSkbJSbjQdRkoMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/account/index.vue")
  },
  {
    name: "admin-dashboard-reports",
    path: "/admin-dashboard/reports",
    meta: index8xQr8T8nSv3wKZCxwSPj0s7GxM3Yz7AyuS_70pA503AMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/reports/index.vue")
  },
  {
    name: "admin-dashboard-schools",
    path: "/admin-dashboard/schools",
    meta: { ...(indexCiHqJE_45PwET6LBRdhmIf0_45_45kP_5kEFOc54zq6JbF_JwMeta || {}), ...{"middleware":["superuser-admin"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/schools/index.vue")
  },
  {
    name: "dashboard-account-choose-plan",
    path: "/dashboard/account/choose-plan",
    meta: choose_45planbCxcbDP8ALCqiv7VFOZYai2tZWx0slJERCxE4GXBXmMMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/account/choose-plan.vue")
  },
  {
    name: "school-teacher-bookings",
    path: "/school-teacher/bookings",
    meta: indexLIX2TEnnJta45ZbcoL5tDM1cFE99iuRnpTAfFuPsV7IMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/bookings/index.vue")
  },
  {
    name: "school-teacher-materials-id",
    path: "/school-teacher/materials/:id()",
    meta: _91id_93CAHFPTaBe0pee8FOkV3WpLks85qJO9WdOiNP1a0WF2EMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/materials/[id].vue")
  },
  {
    name: "school-teacher-students",
    path: "/school-teacher/students",
    meta: indexFg7tsj1NkXcJrF_Cl_45MSlL_45uU8ZQUvw4nn0CIPPTingMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/students/index.vue")
  },
  {
    name: "admin-dashboard-bookings",
    path: "/admin-dashboard/bookings",
    meta: { ...(index_lrP55LP3TG1khWT3hCEc_V9_45vi0xcbdllFFEzIA88wMeta || {}), ...{"middleware":["superuser-admin"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/bookings/index.vue")
  },
  {
    name: "admin-dashboard-documents-id",
    path: "/admin-dashboard/documents/:id()",
    meta: _91id_93b9zjXwoguTg0MJvwntt704r8EN_JEa6HvDU0Kz2HqPUMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/documents/[id].vue")
  },
  {
    name: "admin-dashboard-webhooks",
    path: "/admin-dashboard/webhooks",
    meta: indexBsTEUv4p_45QeLenp57PzzI2L6pwUyFefxNtyLxCIwNEMMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/webhooks/index.vue")
  },
  {
    name: "dashboard-students-studentId",
    path: "/dashboard/students/:studentId()",
    meta: _91studentId_93MSCpNZrAjU426wevufKD4B_e0Kf189AigdYC3Pqm4CsMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/students/[studentId].vue")
  },
  {
    name: "school-dashboard-entries",
    path: "/school-dashboard/entries",
    meta: indexDO9UbiYXcy__GQEQRNbBS8pnp2w6R8zRVhj09cmTTREMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/entries/index.vue")
  },
  {
    name: "school-dashboard-finance",
    path: "/school-dashboard/finance",
    meta: indexpf0DO8IZTYPVImG_45BzY1Nai6jrH3m_45qEwvIWfLCwb0sMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/finance/index.vue")
  },
  {
    name: "school-teacher-favorites",
    path: "/school-teacher/favorites",
    meta: indexD7dtyGXEQP4R51__45TIsLsZ7dQCMk2ThsZM3vPgZj6DQMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/favorites/index.vue")
  },
  {
    name: "school-teacher-materials",
    path: "/school-teacher/materials",
    meta: indexY___45R4rRvT8zVTOzVk9It7iTIYDBgzFQ2AtVBDibjRYMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/materials/index.vue")
  },
  {
    name: "admin-dashboard-campaigns",
    path: "/admin-dashboard/campaigns",
    meta: { ...(indexRqc_8ttC2EZLqTlaYlLEkhAL7E5HThk3EhUlezfK51gMeta || {}), ...{"middleware":["superuser-admin"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/campaigns/index.vue")
  },
  {
    name: "admin-dashboard-documents",
    path: "/admin-dashboard/documents",
    meta: indexe6lJyffD0QbO67uQ1lds1zLCo6LhT0ubGRkrql3mI8gMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/documents/index.vue")
  },
  {
    name: "admin-dashboard-redirects",
    path: "/admin-dashboard/redirects",
    meta: { ...(index9M7ApCthdz8nDsIAS5nkOj903zhYWiT_Ce5lugvw48AMeta || {}), ...{"middleware":["superuser-admin"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/redirects/index.vue")
  },
  {
    name: "dashboard-assessments-id-edit",
    path: "/dashboard/assessments/:id()/edit",
    meta: editgA9E0sxFmjJkJ2wHeEeW18gWvWYolEjvTiK7XDLCzfEMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/assessments/[id]/edit.vue")
  },
  {
    name: "school-dashboard-bookings",
    path: "/school-dashboard/bookings",
    meta: indexbDlxt3_45PDl3gnwbKow5IM9XsERqNS38nMbcieqS_45LWUMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/bookings/index.vue")
  },
  {
    name: "school-dashboard-documents-id",
    path: "/school-dashboard/documents/:id()",
    meta: { ...(_91id_93Q01jKAryK6_pD0LN1zYt4v3ILXj8n6HcLD0YXY9MWFoMeta || {}), ...{"middleware":["documents"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/documents/[id].vue")
  },
  {
    name: "school-dashboard-materials-id",
    path: "/school-dashboard/materials/:id()",
    meta: { ...(_91id_9364k1JRQwliAy_452J_45ZSY12EuFYfi_x5UpmtUe0Q6lGEYMeta || {}), ...{"middleware":["school-materials"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/materials/[id].vue")
  },
  {
    name: "school-dashboard-requests",
    path: "/school-dashboard/requests",
    meta: indexhX79rJL8Q90SoEneYfFq6hciGTKCpiM1KXC7iUCyT0sMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/requests/index.vue")
  },
  {
    name: "school-dashboard-students",
    path: "/school-dashboard/students",
    meta: indexEDfX5sqjhHLj_JQo5RhckU5Y2CMl8WKA6ZIBgBreBwsMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/students/index.vue")
  },
  {
    name: "school-teacher-attendance",
    path: "/school-teacher/attendance",
    meta: indexvuOeUUxxqVXrbv91tbX8WVY925LAoBHH02NdwOVgwFgMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/attendance/index.vue")
  },
  {
    name: "school-teacher-classrooms",
    path: "/school-teacher/classrooms",
    meta: indexJwzK4bn95IQFO4OEzCEoFb_GS5dktjUjdNHzfk6i_45LIMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/classrooms/index.vue")
  },
  {
    name: "student-dashboard-payments-id",
    path: "/student-dashboard/payments/:id()",
    meta: _91id_931xZ21nUgvbJjN1XkuJOl7CqTxAsEsVdJVsCDPYOl_45k8Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/student-dashboard/payments/[id].vue")
  },
  {
    name: "student-dashboard-rewards",
    path: "/student-dashboard/rewards",
    meta: indexENbqAHmN4D945XWRi0gZNNIeuiTL5p75gP0DHEdtl_oMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/student-dashboard/rewards/index.vue")
  },
  {
    name: "admin-dashboard-ai-control",
    path: "/admin-dashboard/ai/control",
    meta: { ...(indexhqRGzLRQ6kD8U2qe2MmaViS0LKEQ3UTZa_rx_9igHscMeta || {}), ...{"middleware":["superuser-admin"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/ai/control/index.vue")
  },
  {
    name: "dashboard-assessments-id",
    path: "/dashboard/assessments/:id()",
    meta: indexfZZtWhuzXEc9b3j5X5sZLS5upxfKVsXrtVlKcrz8CBQMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/assessments/[id]/index.vue")
  },
  {
    name: "school-dashboard-documents",
    path: "/school-dashboard/documents",
    meta: { ...(index_UwBPWYGpYac6M_nEY6b222FtjGb8HtAUi84_45Bfb_TcMeta || {}), ...{"middleware":["documents"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/documents/index.vue")
  },
  {
    name: "school-dashboard-interests",
    path: "/school-dashboard/interests",
    meta: { ...(indexN6rFuISDg4jZ8VtQZBK9mE5Ii70Qux4moUi2W0hREsIMeta || {}), ...{"middleware":["school-interests"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/interests/index.vue")
  },
  {
    name: "school-dashboard-materials",
    path: "/school-dashboard/materials",
    meta: { ...(indexkLlWsaMJOVLhoufQtO76FBx6G7u0DznHxOTYhsj9_80Meta || {}), ...{"middleware":["school-materials"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/materials/index.vue")
  },
  {
    name: "school-dashboard-receiving",
    path: "/school-dashboard/receiving",
    meta: index_RPXxdAoCJkaSfqzHBSLvqdNy5LQ8ExxHNIn1LDRJcoMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/receiving/index.vue")
  },
  {
    name: "school-teacher-assessments",
    path: "/school-teacher/assessments",
    meta: indexgA0nL6wTJlSUZlC8M26_oyMRaW7gYNCkyk_4563C_g4eEMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/assessments/index.vue")
  },
  {
    name: "student-dashboard-payments",
    path: "/student-dashboard/payments",
    meta: indexMII7YevWFnhjvxJomjMSDJcrSeBs_456RcLAVy1U_6G_45cMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/student-dashboard/payments/index.vue")
  },
  {
    name: "student-dashboard-requests",
    path: "/student-dashboard/requests",
    meta: index2o7Nf35Vx8gYS_45ncgoXwcpt43iKYKiSNKUNaydJUBO4Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/student-dashboard/requests/index.vue")
  },
  {
    name: "admin-dashboard-assessments",
    path: "/admin-dashboard/assessments",
    meta: indexz9oEn4LGZXQgaemepnF_45zToKENiEjh3R76dceqHAKikMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/assessments/index.vue")
  },
  {
    name: "admin-dashboard-payment-simulator",
    path: "/admin-dashboard/payment/simulator",
    meta: simulatoru80fL_454fk9PsMQZSI7Ccn73nKARVDHWs7xYJg6yZ4oQMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/simulator.vue")
  },
  {
    name: "admin-dashboard-video-calls",
    path: "/admin-dashboard/video-calls",
    meta: { ...(indexDLEkXVp3wBY_JqAEYCGnzl7Zb9H3goPgz4hJIJ1L89MMeta || {}), ...{"middleware":["superuser-admin"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/video-calls/index.vue")
  },
  {
    name: "code-classroomCode-missing-data",
    path: "/code/:classroomCode()/missing-data",
    meta: missing_45data7DsBckKEbTRW5yMuMq9j8czHnez_49fuaVLZz4n6PeYMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/code/[classroomCode]/missing-data.vue")
  },
  {
    name: "dashboard-payment-id-processing",
    path: "/dashboard/payment/:id()/processing",
    meta: processingveeIPq2EfvX5g_45H4sSKAiUC1NsLSxkDRYl_45LU85qw_45QMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/payment/[id]/processing.vue")
  },
  {
    name: "school-dashboard-attendance",
    path: "/school-dashboard/attendance",
    meta: indexaKuduL274uI5UMApqphuVhwwwqa3AGfonkAwqAcjHWIMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/attendance/index.vue")
  },
  {
    name: "school-dashboard-classrooms",
    path: "/school-dashboard/classrooms",
    meta: index1wM3RHCMEOSChjg9C_FuXJRJh0ZzxZzTtMzLpTt1l6UMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/classrooms/index.vue")
  },
  {
    name: "school-dashboard-forms-id",
    path: "/school-dashboard/forms/:id()",
    meta: { ...(indexi9fA62IxXSpwYnET7A_eUoMBxkwLgAavQSPgzpIQSPwMeta || {}), ...{"middleware":["school-forms"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/forms/[id]/index.vue")
  },
  {
    name: "student-dashboard-classrooms-id",
    path: "/student-dashboard/classrooms/:id()",
    meta: _91id_93jJ_455ib3Tz_457BblUlj1XVYBnLU_45SRD2kVQ5Rqw5COuQYMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/student-dashboard/classrooms/[id].vue")
  },
  {
    name: "admin-dashboard-assessments-create",
    path: "/admin-dashboard/assessments/create",
    meta: create4U6Eet33OwoY3uUj_45k7e91OB5wiXQ74GjEccJrMXStQMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/assessments/create.vue")
  },
  {
    name: "dashboard-assessments-id-results",
    path: "/dashboard/assessments/:id()/results",
    meta: resultsHxKLaqY4BxFGM356HPYoPhHH5uFTdxitVMxtGcNlZ20Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/assessments/[id]/results.vue")
  },
  {
    name: "dashboard-documents-generated-id",
    path: "/dashboard/documents/generated/:id()",
    meta: { ...(_91id_93JWtqvX1ZKIPsqDqTeKKF8QEZcQ1e2JnfkkKp6DkN1WMMeta || {}), ...{"middleware":["documents"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/documents/generated/[id].vue")
  },
  {
    name: "dashboard-payment-update-user-data",
    path: "/dashboard/payment/update-user-data",
    meta: update_45user_45dataMi7MuLkyVyYGF6ZNZR90uyT749Ao9GEPh1Mv_45togbfIMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/payment/update-user-data.vue")
  },
  {
    name: "school-dashboard-assessments",
    path: "/school-dashboard/assessments",
    meta: indexWQnzb45W1aYLVjHCcFlIThyChBSuQxuJy1iCt4_45LuKMMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/assessments/index.vue")
  },
  {
    name: "student-dashboard-agreements",
    path: "/student-dashboard/agreements",
    meta: indexhDYrffZ3LcMiMEZ_ugGZczjF_X3dsnAsac4GvMc_45ASsMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/student-dashboard/agreements/index.vue")
  },
  {
    name: "student-dashboard-assessments-id",
    path: "/student-dashboard/assessments/:id()",
    meta: _91id_93ruax59B5Y_7tYfXO3rL7qWIXt22WYQhLTqCVR3xMyaAMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/student-dashboard/assessments/[id].vue")
  },
  {
    name: "teaching-classes-teachingClassId",
    path: "/teaching-classes/:teachingClassId()",
    meta: { ...(_91teachingClassId_93zDqh4dE8kP9AuzSgdOYRNd2V7W5KPFOEfUIgsQOnobEMeta || {}), ...{"middleware":["classroom-auth"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/teaching-classes/[teachingClassId].vue")
  },
  {
    name: "admin-dashboard-ai-cost-audit",
    path: "/admin-dashboard/ai/cost-audit",
    meta: indexIs6KeCmRP4iE21Lq12MEieO53h0YSGDd4j_pH129XNAMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/ai/cost-audit/index.vue")
  },
  {
    name: "admin-dashboard-feature-flags",
    path: "/admin-dashboard/feature-flags",
    meta: index1eNbG4YAZU2S0UBhl2q_45tcIr3tYnl_4523hMF1fpz_45e18Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/feature-flags/index.vue")
  },
  {
    name: "admin-dashboard-notifications",
    path: "/admin-dashboard/notifications",
    meta: indexsXZhakL_RZNLgs_45zqZI_am6KivXbB1XJaHOvazpO05cMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/notifications/index.vue")
  },
  {
    name: "admin-dashboard-payment-coupons-new",
    path: "/admin-dashboard/payment/coupons/new",
    meta: new9F7XQSF5VFD9fHq0JPdypQj4iKDht_lwphX7XsGybMYMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/coupons/new.vue")
  },
  {
    name: "admin-dashboard-storage-audit",
    path: "/admin-dashboard/storage-audit",
    meta: indexd5YzC3Viy6FRoStrX2KQ3kq8wgj4nC10bkmLHDG2y_oMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/storage-audit/index.vue")
  },
  {
    name: "dashboard-payment-id-confirmation",
    path: "/dashboard/payment/:id()/confirmation",
    meta: confirmation2v7r5zlDYZOt373_45yfWMon_vSbhP7L_45NVMR_45zwcXrQoMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/payment/[id]/confirmation.vue")
  },
  {
    name: "dashboard-payment-change-plan",
    path: "/dashboard/payment/change-plan",
    meta: indexpjetWpZ9EQGEZhI7OTQ4o5Y_45oCg8pu7SJlmnA_45WBaYcMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/payment/change-plan/index.vue")
  },
  {
    name: "school-dashboard-documents-settings",
    path: "/school-dashboard/documents/settings",
    meta: { ...(settingsLVFPA_45LoQMQvikduT50DHY8BTrFTAz6PLmFICbctH5sMeta || {}), ...{"middleware":["documents"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/documents/settings.vue")
  },
  {
    name: "school-dashboard-integrations",
    path: "/school-dashboard/integrations",
    meta: indexU8srLvV1Niif35D1Xs7c8zOqaQwkE_45LT2HBkOiVb8tcMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/integrations/index.vue")
  },
  {
    name: "school-dashboard-store-orders",
    path: "/school-dashboard/store/orders",
    meta: indexEH9QN4tYDyjFvHTsuB57_45q5AYzy_mdok4IwlAYCSv1oMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/store/orders/index.vue")
  },
  {
    name: "student-dashboard-assessments",
    path: "/student-dashboard/assessments",
    meta: indexT5P09mWoh2VZj2Ezj704imFEuH4u_KoKLbM_z0UariAMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/student-dashboard/assessments/index.vue")
  },
  {
    name: "admin-dashboard-assessments-policies",
    path: "/admin-dashboard/assessments/policies",
    meta: policiesno2GVbqIAzZMhol5ylvL6WqWG9s50TLhbigaII8uhv4Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/assessments/policies.vue")
  },
  {
    name: "admin-dashboard-payment-orders",
    path: "/admin-dashboard/payment/orders",
    meta: indexBmBHKIpVJ6Kq2Q5iCMVzx0n_JscUcKcl61CnDsrC590Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/orders/index.vue")
  },
  {
    name: "admin-dashboard-payment-products-new",
    path: "/admin-dashboard/payment/products/new",
    meta: newSkWC8SMGjLaKlGeuxfiy9Ixd1wby7JDXOz_7GmyDudQMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/products/new.vue")
  },
  {
    name: "admin-dashboard-users-userId",
    path: "/admin-dashboard/users/:userId()",
    meta: { ...(indexYjHUqnjY_l70qNtajgA7mWJezTJLOlAHnnyrjqdmVt0Meta || {}), ...{"middleware":["superuser-admin"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/users/[userId]/index.vue")
  },
  {
    name: "admin-dashboard-webhooks-webhookId",
    path: "/admin-dashboard/webhooks/:webhookId()",
    meta: _91webhookId_93WtBPJLnV_nutowitEnHh9_4CJKraIaggSGeEtoGrmF8Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/webhooks/[webhookId].vue")
  },
  {
    name: "dashboard-payment-change-credit-card",
    path: "/dashboard/payment/change-credit-card",
    meta: change_45credit_45cardlzMdQzFB8flzgiOswzPYrknhYPzV_hZDqG14_45e2iGY4Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/payment/change-credit-card.vue")
  },
  {
    name: "school-dashboard-notifications",
    path: "/school-dashboard/notifications",
    meta: indexI6cbk8DVrPZOnoSnnSzX9hsCYwQI4KS_xffPqnLd_45GoMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/notifications/index.vue")
  },
  {
    name: "school-teacher-assessments-id-edit",
    path: "/school-teacher/assessments/:id()/edit",
    meta: editJzNPTerxeUNN7yl81THCgKrPEn0aiU2ue62kVJzv9fwMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/assessments/[id]/edit.vue")
  },
  {
    name: "admin-dashboard-assessments-id-edit",
    path: "/admin-dashboard/assessments/:id()/edit",
    meta: editNRrkVP63l_cT4Kx0gTDOJmXzJUAJiwSp4hel3PQ8EJUMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/assessments/[id]/edit.vue")
  },
  {
    name: "admin-dashboard-background-jobs",
    path: "/admin-dashboard/background-jobs",
    meta: indexcoNRd4YDnYNMas63171LPY255bmTUS5GbqHI_Vb3YX0Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/background-jobs/index.vue")
  },
  {
    name: "admin-dashboard-content-quality",
    path: "/admin-dashboard/content-quality",
    meta: { ...(indexsgFBfb5_45M8Qqw_ivsaafemMHm0pu_MzgZ_45rrtwGfe34Meta || {}), ...{"middleware":["content-quality-reviewer","content-quality-run-redirect"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content-quality/index.vue")
  },
  {
    name: "admin-dashboard-payment-coupons",
    path: "/admin-dashboard/payment/coupons",
    meta: indexF3q89Z_uwMkKXNEPTU2thUH8v97LVoT6aMAmbm_k9XQMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/coupons/index.vue")
  },
  {
    name: "dashboard-account-manage-subscription",
    path: "/dashboard/account/manage-subscription",
    meta: manage_45subscription4B2_kUdsqg0canvJX3yllkk_UdRyOYbYlkl4h4uFQp0Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/account/manage-subscription.vue")
  },
  {
    name: "dashboard-payment-change-plan-success",
    path: "/dashboard/payment/change-plan-success",
    meta: change_45plan_45successhlL7NxFrUBmngezWcnxg056dUz_2kiwVmq4iAH5BCa4Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/payment/change-plan-success.vue")
  },
  {
    name: "school-dashboard-interests-id",
    path: "/school-dashboard/interests/:id()",
    meta: { ...(indexXzU0o3okHCZNiqmVWOFqFJBlVEpz26TlsAFKR8RgkD0Meta || {}), ...{"middleware":["school-interests"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/interests/[id]/index.vue")
  },
  {
    name: "school-dashboard-store-settings",
    path: "/school-dashboard/store/settings",
    meta: indexwvDprKEC5LIZ_45N_e3CnNHrIsR9tghHm_fxluPxuo66AMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/store/settings/index.vue")
  },
  {
    name: "school-teacher-assessments-id",
    path: "/school-teacher/assessments/:id()",
    meta: indexGGX_45CSW_45Is2_QbSG3kXkR1MhLWHyF2OcowRxHczScb8Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/assessments/[id]/index.vue")
  },
  {
    name: "admin-dashboard-assessments-id",
    path: "/admin-dashboard/assessments/:id()",
    meta: indexpDjFLmedMuqsgXWQBnh8yqPl36ZfVBt3Ake8ni0GPAMMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/assessments/[id]/index.vue")
  },
  {
    name: "admin-dashboard-content-quality-audits",
    path: "/admin-dashboard/content-quality/audits",
    meta: { ...(auditst57KCYoVWIkHEek1AURUDkhMKkwUvnquN_454XLqvMykoMeta || {}), ...{"middleware":["superuser-admin"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content-quality/audits.vue")
  },
  {
    name: "admin-dashboard-outreach-schools",
    path: "/admin-dashboard/outreach/schools",
    meta: { ...(indexMru_4C4SmbjdS51CBlfDdNau8WyjXbTqmVoSp35rodIMeta || {}), ...{"middleware":["superuser-admin"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/outreach/schools/index.vue")
  },
  {
    name: "admin-dashboard-payment-products",
    path: "/admin-dashboard/payment/products",
    meta: index3_v0vpAO_4FT5LBmdMSUbV9SGYatQrPpuoTWrLhV7RcMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/products/index.vue")
  },
  {
    name: "school-dashboard-assessments-id-edit",
    path: "/school-dashboard/assessments/:id()/edit",
    meta: editCrWSkGtrGMPkzedlSHDz1Xm_Whea4IJC6WiR9C16vi0Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/assessments/[id]/edit.vue")
  },
  {
    name: "admin-dashboard-payment-referrals",
    path: "/admin-dashboard/payment/referrals",
    meta: { ...(indexSwSq71Z1eWyBViexoFgp5lXo9KpXfIq_45qIQ4xXEvk5QMeta || {}), ...{"middleware":["superuser-admin"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/referrals/index.vue")
  },
  {
    name: "admin-dashboard-user-access-configs-new",
    path: "/admin-dashboard/user-access-configs/new",
    meta: { ...(new_G0YwyH8GJeT9fKBM_45jTLh0APp_45Xd49EWY_45aWYz_45OQ4Meta || {}), ...{"middleware":["superuser-admin"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/user-access-configs/new.vue")
  },
  {
    name: "school-dashboard-assessments-id",
    path: "/school-dashboard/assessments/:id()",
    meta: indexS5WoLcpVs08mZ_p9CyRq3CgSNyD86iqcc_UozSDgv1IMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/assessments/[id]/index.vue")
  },
  {
    name: "school-dashboard-store-categories",
    path: "/school-dashboard/store/categories",
    meta: indexrIqTacPUoQ8r6US0VIJoJNzY1K4LASqSeHB7VTXU0T4Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/store/categories/index.vue")
  },
  {
    name: "school-teacher-assessments-id-results",
    path: "/school-teacher/assessments/:id()/results",
    meta: resultsGUrYBHn2V8PpA4c4Kn_oCsQlbe28gELyx8tleOO_456_oMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/assessments/[id]/results.vue")
  },
  {
    name: "admin-dashboard-content-lesson-plans-new",
    path: "/admin-dashboard/content/lesson-plans/new",
    meta: newI_45bg72Rhn1EBihJCakYKuOevMU_TnWP6z0ZARqe1LSEMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content/lesson-plans/new.vue")
  },
  {
    name: "admin-dashboard-payment-orders-orderId",
    path: "/admin-dashboard/payment/orders/:orderId()",
    meta: _91orderId_931mVkBm3i_LINR8qJR1WmZQs9v6Lh9l0YlGFUh2YEJYQMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/orders/[orderId].vue")
  },
  {
    name: "code-classroomCode-student-login-token",
    path: "/code/:classroomCode()/student-login-token",
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/code/[classroomCode]/student-login-token.vue")
  },
  {
    name: "dashboard-classrooms-classroomId",
    path: "/dashboard/classrooms/:classroomId()",
    meta: index3eV3r4WE_45EghNwX21eXns6w9bRpkx7PuMDtwevkScBgMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/classrooms/[classroomId]/index.vue")
  },
  {
    name: "dashboard-documents-preview-templateId",
    path: "/dashboard/documents/preview/:templateId()",
    meta: { ...(_91templateId_93zBzfKnAoVRuTwW_2YKo5BbhSttovhiKuefxvc9nGKmAMeta || {}), ...{"middleware":["documents"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/documents/preview/[templateId].vue")
  },
  {
    name: "dashboard-payment-id-user-payment-data",
    path: "/dashboard/payment/:id()/user-payment-data",
    meta: user_45payment_45datap8wNj8U6CRU9zTV7obM_BnjKU5tv_45XFlgM8gaBJr3dQMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/payment/[id]/user-payment-data.vue")
  },
  {
    name: "admin-dashboard-assessments-bulk-generate",
    path: "/admin-dashboard/assessments/bulk-generate",
    meta: bulk_45generatehn4ygWIXt88IN5Zh2kG8cZt24RgCBXuXzDXZiUNiOc8Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/assessments/bulk-generate.vue")
  },
  {
    name: "admin-dashboard-content-all-lessons",
    path: "/admin-dashboard/content/all-lessons",
    meta: index2fssuGBkJp7bAfaByRYvEfTS3lqQdKKKGD5on5ucABwMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content/all-lessons/index.vue")
  },
  {
    name: "admin-dashboard-user-access-configs",
    path: "/admin-dashboard/user-access-configs",
    meta: { ...(indexpH5Wf4qB9knyRwBdtpmScj6pxAPV_45YS_EOFB1IIDXgMMeta || {}), ...{"middleware":["superuser-admin"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/user-access-configs/index.vue")
  },
  {
    name: "school-dashboard-documents-generated-id",
    path: "/school-dashboard/documents/generated/:id()",
    meta: { ...(_91id_932AnCVy6CZnJBkBrbT5vsGEohiXWiC51NxhOo_45DS_45U0AMeta || {}), ...{"middleware":["documents"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/documents/generated/[id].vue")
  },
  {
    name: "school-teacher-students-studentId",
    path: "/school-teacher/students/:studentId()",
    meta: index1cC3TIHoggSIXT6eTmzsADt6QlceLacxIRH4_45U00S98Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/students/[studentId]/index.vue")
  },
  {
    name: "admin-dashboard-assessments-attempts",
    path: "/admin-dashboard/assessments/attempts",
    meta: index5PQSJAB46V4_45fTNvRfAX_l9UF6Zsf5Te1sOBfNkubh0Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/assessments/attempts/index.vue")
  },
  {
    name: "admin-dashboard-content-lesson-plans",
    path: "/admin-dashboard/content/lesson-plans",
    meta: index7CjhZZOFlmdqTOOBAlTaVbLIW6oAFbirDqb_0E0eeKwMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content/lesson-plans/index.vue")
  },
  {
    name: "admin-dashboard-payment-subscriptions",
    path: "/admin-dashboard/payment/subscriptions",
    meta: indexY7uNACK08sPsHpg4yLkllqBgxHWP_Wha4BTxP1W5RGoMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/subscriptions/index.vue")
  },
  {
    name: "school-dashboard-students-studentId-entry",
    path: "/school-dashboard/students/:studentId()/entry",
    meta: entry9NQmVNeLkD7tZP4q7z_k36l1xGexcqQt_tFd0UPXebQMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/students/[studentId]/entry.vue")
  },
  {
    name: "school-dashboard-students-studentId",
    path: "/school-dashboard/students/:studentId()",
    meta: indexigE_457luoRiUUYx6eZIc9RpDUyNlM7BuPN5ixYsXubYcMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/students/[studentId]/index.vue")
  },
  {
    name: "admin-dashboard-content-lesson-plans-reorder",
    path: "/admin-dashboard/content/lesson-plans/reorder",
    meta: reorderDqS1tEP8WUw5m5JhUP7aaM2Y2Xo8PLRweC2fN9bYHusMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content/lesson-plans/reorder.vue")
  },
  {
    name: "admin-dashboard-notifications-whatsapp",
    path: "/admin-dashboard/notifications/whatsapp",
    meta: { ...(index2f0geLQEvEDtJ10kMaYHxXeeIgKMdftzSqBfNAwLmycMeta || {}), ...{"middleware":["superuser-admin"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/notifications/whatsapp/index.vue")
  },
  {
    name: "admin-dashboard-content-quality-reports",
    path: "/admin-dashboard/content-quality/reports",
    meta: { ...(indexwBIFy1s3cS8gw4N3RUKHcaT6s8bKNr5EDF8U3eRRzBkMeta || {}), ...{"middleware":["superuser-admin"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content-quality/reports/index.vue")
  },
  {
    name: "dashboard-payment-success-updated-credit-card",
    path: "/dashboard/payment/success-updated-credit-card",
    meta: success_45updated_45credit_45cardY9xD_FKUklPpquHgvAeZYb_45juRLFxaxxUOVYmzqyYEcMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/payment/success-updated-credit-card.vue")
  },
  {
    name: "school-teacher-classrooms-classroomId",
    path: "/school-teacher/classrooms/:classroomId()",
    meta: indexetoVOb6UFyw1vR0vDLXPgwkctlJuyuY02umeCpiCH3kMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/classrooms/[classroomId]/index.vue")
  },
  {
    name: "admin-dashboard-payment-payment-processors-new",
    path: "/admin-dashboard/payment/payment-processors/new",
    meta: newrtVPrhCgyfpnm_45rgoG2U0iiOhzvVDLqXBMXttheR9iEMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/payment-processors/new.vue")
  },
  {
    name: "admin-dashboard-payment-subscription-plans-new",
    path: "/admin-dashboard/payment/subscription-plans/new",
    meta: { ...(newhh9D2ZW8QRwT_hrHIFqXc3XOfjecVsLhd53T1bwuxxIMeta || {}), ...{"middleware":["superuser-admin"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/subscription-plans/new.vue")
  },
  {
    name: "admin-dashboard-entitlements-usage-events",
    path: "/admin-dashboard/entitlements/usage-events",
    meta: { ...(index9A2sZA5DrMSfHyOxLzUh_45_XTC9R2VWJy36FR8FznWN8Meta || {}), ...{"middleware":["superuser-admin"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/entitlements/usage-events/index.vue")
  },
  {
    name: "admin-dashboard-payment-coupons-couponId-edit",
    path: "/admin-dashboard/payment/coupons/:couponId()/edit",
    meta: editPqDJpgAAOhdLteJWfYf_45YprpdRTsoUIgZMZS_wuiNdQMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/coupons/[couponId]/edit.vue")
  },
  {
    name: "dashboard-assessments-id-attempts-attemptId",
    path: "/dashboard/assessments/:id()/attempts/:attemptId()",
    meta: _91attemptId_93RaSDj0N2vC6VytSrmQiluIesi3nshahB2cxQgQibUMYMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/assessments/[id]/attempts/[attemptId].vue")
  },
  {
    name: "school-dashboard-classrooms-classroomId",
    path: "/school-dashboard/classrooms/:classroomId()",
    meta: indexjhCyTVnubGC1xDsLOmDNGhezgwLMRT1T33cNQQ93NKMMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/classrooms/[classroomId]/index.vue")
  },
  {
    name: "school-dashboard-documents-preview-templateId",
    path: "/school-dashboard/documents/preview/:templateId()",
    meta: { ...(_91templateId_93MtHRYdoRTMfB1IaS0XhGqgwO2YzY4KptbHOck0jm7CsMeta || {}), ...{"middleware":["documents"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/documents/preview/[templateId].vue")
  },
  {
    name: "admin-dashboard-assessments-attempts-attemptId",
    path: "/admin-dashboard/assessments/attempts/:attemptId()",
    meta: _91attemptId_93WOdht1yHRwqO6oiol8M4EVtdMxxYLKHZjyc3u9_455HKwMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/assessments/attempts/[attemptId].vue")
  },
  {
    name: "admin-dashboard-content-quality-lessonId",
    path: "/admin-dashboard/content-quality/:lessonId()",
    meta: { ...(indexnxyxcI14xUaDFpX2_45yURdQa3Is5rpJoxuynXI_45T09qcMeta || {}), ...{"middleware":["content-quality-reviewer"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content-quality/[lessonId]/index.vue")
  },
  {
    name: "admin-dashboard-payment-payment-processors",
    path: "/admin-dashboard/payment/payment-processors",
    meta: indexkTqizuG4SXOu3FymzDllljVZOdKfNdsUtROT_45b9AKvgMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/payment-processors/index.vue")
  },
  {
    name: "admin-dashboard-payment-subscription-plans",
    path: "/admin-dashboard/payment/subscription-plans",
    meta: { ...(indexKSOQo27t4W8Z6d_45IfxSWui2ak7TO8ezDM2jp_MgrR3UMeta || {}), ...{"middleware":["superuser-admin"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/subscription-plans/index.vue")
  },
  {
    name: "admin-dashboard-assessments-id-questions-create",
    path: "/admin-dashboard/assessments/:id()/questions/create",
    meta: createpSxWEpZJegrEfgVUPliQBc_LzFQI9J4b0l1XJZaXVykMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/assessments/[id]/questions/create.vue")
  },
  {
    name: "admin-dashboard-content-quality-reports-reportId",
    path: "/admin-dashboard/content-quality/reports/:reportId()",
    meta: { ...(_91reportId_93Ba418QIhKjD_IzGG8GfLFszqVQoZhitEEv8_45UQVjexEMeta || {}), ...{"middleware":["superuser-admin"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content-quality/reports/[reportId].vue")
  },
  {
    name: "admin-dashboard-user-access-configs-configId-edit",
    path: "/admin-dashboard/user-access-configs/:configId()/edit",
    meta: { ...(editdeVkp2qWzSZsyHgJKkoXRww0qs7WoceUBnlOtnkQxr0Meta || {}), ...{"middleware":["superuser-admin"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/user-access-configs/[configId]/edit.vue")
  },
  {
    name: "school-teacher-assessments-id-attempts-attemptId",
    path: "/school-teacher/assessments/:id()/attempts/:attemptId()",
    meta: _91attemptId_93DQG_l2BKk7QZ9Kzv_45HwNhj1rnDWItJYDq4QSr2eNZDcMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/assessments/[id]/attempts/[attemptId].vue")
  },
  {
    name: "school-dashboard-assessments-id-contacts-contactId",
    path: "/school-dashboard/assessments/:id()/contacts/:contactId()",
    meta: _91contactId_93h7KDuywjzp69_459Yc4JmrZTQyio7md9No7iYp_45r_eC44Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-dashboard/assessments/[id]/contacts/[contactId].vue")
  },
  {
    name: "admin-dashboard-payment-subscription-plans-provider-new",
    path: "/admin-dashboard/payment/subscription-plans/provider/new",
    meta: newsWUffrftCzAISgEN9aQmGL3k1Jbdvek8QkYS0M720jcMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/subscription-plans/provider/new.vue")
  },
  {
    name: "admin-dashboard-content-lesson-plans-lessonPlanId-edit",
    path: "/admin-dashboard/content/lesson-plans/:lessonPlanId()/edit",
    meta: edit5bsmSPp4cFnG_45WuymYZYJ49LeUZTyWtfCoVoRwH2uAYMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content/lesson-plans/[lessonPlanId]/edit.vue")
  },
  {
    name: "admin-dashboard-content-lesson-plans-lessonPlanId",
    path: "/admin-dashboard/content/lesson-plans/:lessonPlanId()",
    meta: indexkwMUzl96aumUaobF_45cENwt9OO1GNh3qazyJjF4fozNkMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content/lesson-plans/[lessonPlanId]/index.vue")
  },
  {
    name: "admin-dashboard-payment-subscription-plans-provider",
    path: "/admin-dashboard/payment/subscription-plans/provider",
    meta: indexG33x2uObCotUfzyta1QPt1fjNG73ehWD2mTaMCTE_MAMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/subscription-plans/provider/index.vue")
  },
  {
    name: "admin-dashboard-payment-pagarme-charges-providerChargeId",
    path: "/admin-dashboard/payment/pagarme/charges/:providerChargeId()",
    meta: _91providerChargeId_93Ekx8dcAWbfaytsmmUMHXN5n1ZUbH_45jFpkWPv_45taMt48Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/pagarme/charges/[providerChargeId].vue")
  },
  {
    name: "admin-dashboard-payment-pagarme-invoices-providerInvoiceId",
    path: "/admin-dashboard/payment/pagarme/invoices/:providerInvoiceId()",
    meta: _91providerInvoiceId_93mXvIprpK_45k7wrDaKZ9OBtavlhkncIqnIkZkxmZT9sPgMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/pagarme/invoices/[providerInvoiceId].vue")
  },
  {
    name: "admin-dashboard-payment-subscriptions-subscriptionId",
    path: "/admin-dashboard/payment/subscriptions/:subscriptionId()",
    meta: indexWnpxvLAFywVNz8YS69IB3decoJ6opR8UNZ49YZ3jYWkMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/subscriptions/[subscriptionId]/index.vue")
  },
  {
    name: "admin-dashboard-content-lesson-plans-lessonPlanId-lessons-new",
    path: "/admin-dashboard/content/lesson-plans/:lessonPlanId()/lessons/new",
    meta: new9ACt_45fPCI5mJLbdDtjNxxsImku1nhBrjeVmprjWOE_45sMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content/lesson-plans/[lessonPlanId]/lessons/new.vue")
  },
  {
    name: "dashboard-payment-change-plan-subscriptionPlanId-confirmation",
    path: "/dashboard/payment/change-plan/:subscriptionPlanId()/confirmation",
    meta: confirmationw9AYtd2IAtYxcscycJwnrrjLoSOGMSEYUZ3UWZf2oLEMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/payment/change-plan/[subscriptionPlanId]/confirmation.vue")
  },
  {
    name: "admin-dashboard-content-lesson-plans-lessonPlanId-lessons",
    path: "/admin-dashboard/content/lesson-plans/:lessonPlanId()/lessons",
    meta: indexKjSbuUuJ276WFmDtaBwuyDWSioOwNFzGPQs_FD261fUMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content/lesson-plans/[lessonPlanId]/lessons/index.vue")
  },
  {
    name: "admin-dashboard-payment-subscription-plans-subscriptionPlanId-edit",
    path: "/admin-dashboard/payment/subscription-plans/:subscriptionPlanId()/edit",
    meta: { ...(edith48u072diLSMZSm6TSHZiOcFJjT9sdaYIg_IB0l3DecMeta || {}), ...{"middleware":["superuser-admin"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/subscription-plans/[subscriptionPlanId]/edit.vue")
  },
  {
    name: "admin-dashboard-payment-subscription-plans-subscriptionPlanId",
    path: "/admin-dashboard/payment/subscription-plans/:subscriptionPlanId()",
    meta: { ...(indexWMDrV3B_efRwWOoSPNrlULJ_MMyGkYLsUbrBWyUSZQwMeta || {}), ...{"middleware":["superuser-admin"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/payment/subscription-plans/[subscriptionPlanId]/index.vue")
  },
  {
    name: "admin-dashboard-content-quality-revisions-revisionId-preview-variant",
    path: "/admin-dashboard/content-quality/revisions/:revisionId()/preview/:variant()",
    meta: { ...(_91variant_93E2ofyOzVnhdR8izufvrzsumwSjU_jazLKMmrnrb0IEIMeta || {}), ...{"middleware":["content-quality-reviewer"]} },
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content-quality/revisions/[revisionId]/preview/[variant].vue")
  },
  {
    name: "admin-dashboard-content-lesson-plans-lessonPlanId-lessons-lessonId-edit",
    path: "/admin-dashboard/content/lesson-plans/:lessonPlanId()/lessons/:lessonId()/edit",
    meta: edit_bkfb4O3ksUk5_5knsleNagP3iAoStlj58ZnduQ4zP8Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content/lesson-plans/[lessonPlanId]/lessons/[lessonId]/edit.vue")
  },
  {
    name: "admin-dashboard-content-lesson-plans-lessonPlanId-lessons-lessonId",
    path: "/admin-dashboard/content/lesson-plans/:lessonPlanId()/lessons/:lessonId()",
    meta: indexLNt9ipwpw0YFCLO0jKj2NGMFaIpVmvhBz21B93_45MXMUMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/admin-dashboard/content/lesson-plans/[lessonPlanId]/lessons/[lessonId]/index.vue")
  },
  {
    name: "dashboard-complementary-activities-sourceType-sourceId-assessmentId-customize",
    path: "/dashboard/complementary-activities/:sourceType()/:sourceId()/:assessmentId()/customize",
    meta: customizeqMk3pKMKPpIX1lWAR_45NAOoHVSAOauZbUZBCJRGwzEX8Meta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/dashboard/complementary-activities/[sourceType]/[sourceId]/[assessmentId]/customize.vue")
  },
  {
    name: "school-teacher-complementary-activities-sourceType-sourceId-assessmentId-customize",
    path: "/school-teacher/complementary-activities/:sourceType()/:sourceId()/:assessmentId()/customize",
    meta: customizeXun9wmR8MPvNH5FGMuecBaZReYR4RAhgncmhHY3Vo2sMeta || {},
    component: () => import("/codebuild/output/src145292705/src/teachplus-web/pages/school-teacher/complementary-activities/[sourceType]/[sourceId]/[assessmentId]/customize.vue")
  }
]